// Function to delay any scripting.
// Use `name` as uniq queue. Timeout will be overwritten for multiple calls in period of `ms` defined.
let delayTimer = {};
let delay = (function () {
    delayTimer[name] = 0;
    return function (callback, ms, name) {
        clearTimeout(delayTimer[name]);
        delayTimer[name] = setTimeout(callback, ms);
    };
})();

$(function () {
    let $body = $("body");

    // Popovers
    $(".new-popover").webuiPopover({animation: "pop", width: 250});

    // Lazy load
    const lazyLoadConfig = {
        rootMargin: '0px 0px 50px 0px',
        threshold: 0
    };

    let preloadLazyImage = function (element) {
        let $e = $(element),
            $picture = $("<picture></picture>");

        if ($e.data("wset")) {
            $picture.append($("<source>").attr("srcset", $e.data("wset")).attr("type", $e.data("w")));
        }
        if ($e.data("oset")) {
            $picture.append($("<source>").attr("srcset", $e.data("oset")).attr("type", $e.data("o")));
        }

        let img = new Image();

        img.src = $e.data("src");
        if ($e.attr("width") > 0) {
            img.width = $e.attr("width");
        }
        if ($e.attr("height") > 0) {
            img.height = $e.attr("height");
        }
        img.alt = $e.attr("alt");
        img.className = $e.attr("class");

        $picture.append($(img));

        $e.replaceWith($picture);
    };

    let observer = new IntersectionObserver(function(entries, self) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                if (entry.target.classList.contains('section-lazy-load')) {
                    entry.target.querySelectorAll("[data-lazy-section]").forEach(img => {
                        preloadLazyImage(img);
                    });
                } else {
                    preloadLazyImage(entry.target);
                }
                self.unobserve(entry.target);
            }
        });
    }, lazyLoadConfig);

    const images = document.querySelectorAll("[data-lazy]");
    images.forEach(img => {
        observer.observe(img);
    });

    const sections = document.querySelectorAll(".section-lazy-load");
    sections.forEach(section => {
        observer.observe(section);
    });

    // Spinner
    window.showSimpleSpinner = function (options = {}, $spinner) {
        $spinner = $spinner || $("#spinner-main").eq(0);

        if ($spinner.data("showing")) {
            return;
        }

        $spinner.data("showing", true);

        options = Object.assign({
            noFadeTime: false,
            blink: false,
            sizeClass: false
        }, options);

        if (options.sizeClass) {
            $spinner.addClass(options.sizeClass);
        }

        let itemsVisible = false,
            $items = $spinner.find(".line"),
            animateSpinner = function () {
                if (options.blink) {
                    $items.removeClass("spinner-animated-blink");
                    $items.addClass("spinner-animated-pre-blink");
                    setTimeout(function () {
                        $items.addClass("spinner-animated-blink");
                        $items.removeClass("spinner-animated-pre-blink");
                    }, 0);

                    $spinner.data("animationTimeout", setTimeout(animateSpinner, 2500));
                } else {
                    $items.removeClass("spinner-animated-pre");
                    if (itemsVisible) {
                        $items.removeClass("spinner-animated-show");
                        $items.addClass("spinner-animated-hide");
                    } else {
                        $items.removeClass("spinner-animated-hide");
                        $items.addClass("spinner-animated-show");
                    }
                    itemsVisible = !itemsVisible;

                    $spinner.data("animationTimeout", setTimeout(animateSpinner, 1500));
                }
            };

        if (!options.blink) {
            itemsVisible = true;
            $items.addClass("spinner-animated-pre");

            $spinner.data("animationTimeout", setTimeout(animateSpinner, 800));
        }

        $spinner.fadeIn((options.noFadeTime ? 0 : 200), function () {
            if (options.blink) {
                animateSpinner();
            }
        });
    };

    window.hideSimpleSpinner = function (options = {}, $spinner) {
        $spinner = $spinner || $("#spinner-main").eq(0);

        if (!$spinner.data("showing")) {
            return;
        }

        options = Object.assign({
            noFadeTime: false
        }, options);

        let $items = $spinner.find(".line");

        $spinner.fadeOut((options.noFadeTime ? 0 : 200), function () {
            $items.removeClass("spinner-animated-hide");
            $items.removeClass("spinner-animated-show");
            $items.removeClass("spinner-animated-blink");
            $items.removeClass("spinner-animated-pre-blink");
            clearTimeout($spinner.data("animationTimeout"));
        });
        $spinner.data("showing", false);
    };
});
